/**
 * @type {ng.IDirectiveFactory}
 * @param {ng.IQService} $q
 * @param {import('../core').UserService} userService
 */
export default function verifyEmailAvailabilityDirective($q, userService) {
  'ngInject'

  return {
    restrict: 'A',
    require: 'ngModel',
    link(scope, elem, attrs, controller) {
      const ngModel = /** @type {ng.INgModelController} */ (controller)
      ngModel.$asyncValidators.email = (modelValue, viewValue) =>
        userService.isUserNameAvailable(modelValue || viewValue)
    }
  }
}
